import React, { useEffect, useRef, useState } from 'react';

export default function Experience() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="experience" className="experience-section" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">Experience</h2>
        <div className={`experience-timeline ${isVisible ? 'visible' : ''}`}>
          <div className="experience-card">
            <div className="experience-icon">
              <i className="fas fa-briefcase"></i>
            </div>
            <div className="experience-content">
              <h3>UNIQUE IT SOLUTION</h3>
              <div className="experience-meta">
                <span className="experience-role">
                  <i className="fas fa-user-tie"></i> IT Professional
                </span>
                <span className="experience-location">
                  <i className="fas fa-map-marker-alt"></i> Tiruvannamalai, Tamil Nadu
                </span>
                <span className="experience-date">
                  <i className="fas fa-calendar-alt"></i> 08/2022 - 12/2024
                </span>
              </div>
              <p className="experience-description">
                IT solutions company providing comprehensive hardware and software services
              </p>
              <ul className="experience-highlights">
                <li>
                  <i className="fas fa-check-circle"></i>
                  Diagnosed and resolved complex system hardware issues including components, peripherals, and performance optimization
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  Managed system configurations, software installations, and network troubleshooting for diverse client environments
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
                  Improved system efficiency and reliability through proactive maintenance and strategic upgrades
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
